import { render } from "./MSEditModal.vue?vue&type=template&id=e2a6057c&scoped=true&ts=true"
import script from "./MSEditModal.vue?vue&type=script&lang=ts"
export * from "./MSEditModal.vue?vue&type=script&lang=ts"

import "./MSEditModal.vue?vue&type=style&index=0&id=e2a6057c&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a6057c"]])

export default __exports__